document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".custom-dropdown").forEach(dropdown => {
        const dropdownList = dropdown.querySelector(".dropdown-list");
        const radioButtons = dropdownList.querySelectorAll("input[type='radio']");
        const selectedValue = dropdown.closest("fieldset").querySelector(".form__label__value")?.textContent.trim();

        const arrows = {
            down: `<svg class="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"></path></svg>`,
            up: `<svg class="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"></path></svg>`
        };

        const dropdownBtn = document.createElement("button");
        dropdownBtn.classList.add("dropdown-btn");

        // Set initial button text and active class
        let selectedLabel = "Select an option"; 
        radioButtons.forEach(input => {
            const parentItem = input.closest(".dropdown-item");
            if (input.value.trim() === selectedValue) {
                selectedLabel = input.nextElementSibling.innerHTML;
                parentItem.classList.add("active"); // Mark selected item as active
            } else {
                parentItem.classList.remove("active");
            }
        });

        dropdownBtn.innerHTML = `<span class="dropdown-text">${selectedLabel}</span> ${arrows.down}`;
        dropdown.insertBefore(dropdownBtn, dropdownList);

        dropdownBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            const isOpen = dropdownList.classList.toggle("show");
            dropdownBtn.innerHTML = `<span class="dropdown-text">${dropdownBtn.querySelector(".dropdown-text").innerHTML}</span> ${isOpen ? arrows.up : arrows.down}`;
        });

        radioButtons.forEach(input => {
            input.addEventListener("change", function () {
                // Remove active class from all items
                dropdownList.querySelectorAll(".dropdown-item").forEach(item => item.classList.remove("active"));

                // Add active class to selected item
                const parentItem = this.closest(".dropdown-item");
                parentItem.classList.add("active");

                dropdownBtn.innerHTML = `<span class="dropdown-text">${this.nextElementSibling.innerHTML}</span> ${arrows.down}`;
                dropdownList.classList.remove("show");
            });
        });

        document.addEventListener("click", (e) => {
            if (!dropdown.contains(e.target)) {
                dropdownList.classList.remove("show");
                dropdownBtn.innerHTML = `<span class="dropdown-text">${dropdownBtn.querySelector(".dropdown-text").innerHTML}</span> ${arrows.down}`;
            }
        });
    });
});

//Before/after custom section
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.image-comparison__range');
  const mobileImages = document.querySelectorAll('.mobile-image');
  const desktopImages = document.querySelectorAll('.desktop-image');

  sliders.forEach(slider => {
    const container = slider.closest('.image-comparison__slider-wrapper');
    const imageBefore = container.querySelector('.image-comparison__image-wrapper--overlay');
    const sliderThumb = container.querySelector('.image-comparison__slider');

    slider.addEventListener('input', (e) => {
      let percentage = e.target.value;
      imageBefore.style.width = percentage + "%";
      sliderThumb.style.left = percentage + "%";
    });
  });
});
